
import React from 'react';
import { Link } from 'react-router-dom';
import { SOCIAL_LINKS, SocialIcon } from './SocialIcons';

const Footer: React.FC = () => {
  return (
    <footer className="w-full border-t border-gray-200 bg-white py-16 px-4 md:px-10">
      <div className="max-w-[1400px] mx-auto w-full flex flex-col md:flex-row justify-between gap-12">
        <div className="max-w-md">
          <div className="flex items-center gap-2 text-black mb-6">
            <div className="size-12 text-primary">
              {/* SUSTITUYE ESTE SVG POR <img src="/tu-logo.png" className="h-full" /> */}
              	<img src="/logo.png" alt="Logo" className="h-full w-full object-contain" />
            </div>
            <h2 className="text-black text-xl font-black tracking-tighter">SANAN</h2>
          </div>
          <p className="text-gray-500 mb-6">Esta marca nace de la pasión por el motor. Cada diseño está creado por un auténtico amante de los coches y pensado para todos los que sienten lo mismo.
Desde siluetas minimalistas hasta ilustraciones de deportivos y clásicos icónicos, aquí encontrarás ropa y accesorios creados con el mismo espíritu con el que se vive el mundo del motor: con pasión, estilo y autenticidad.</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-16">
          <div className="flex flex-col gap-4">
            <h4 className="text-black font-bold uppercase tracking-wide text-sm italic">Tienda</h4>
            <Link to="/shop" className="text-gray-500 hover:text-black transition-colors text-sm">Novedades</Link>
            <Link to="/collections" className="text-gray-500 hover:text-black transition-colors text-sm">Colecciones</Link>
          </div>
          <div className="flex flex-col gap-4">
            <h4 className="text-black font-bold uppercase tracking-wide text-sm italic">Soporte</h4>
            <Link to="/contact" className="text-gray-500 hover:text-black transition-colors text-sm">Contacto</Link>
          </div>
<div className="flex flex-col gap-4">
  <h4 className="text-black font-bold uppercase tracking-wide text-sm italic">Legal</h4>
  <Link to="/aviso-legal" className="text-gray-500 hover:text-black transition-colors text-sm">Aviso Legal</Link>
  <Link to="/privacidad" className="text-gray-500 hover:text-black transition-colors text-sm">Política de Privacidad</Link>
  <Link to="/cookies" className="text-gray-500 hover:text-black transition-colors text-sm">Cookies</Link>
  <Link to="/terminos" className="text-gray-500 hover:text-black transition-colors text-sm">Términos y Condiciones</Link>
  <Link to="/envios-devoluciones" className="text-gray-500 hover:text-black transition-colors text-sm">Envíos y Devoluciones</Link>
</div>
          <div className="flex flex-col gap-4">
            <h4 className="text-black font-bold uppercase tracking-wide text-sm italic">Síguenos</h4>
            {SOCIAL_LINKS.map(s => (
              <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-500 hover:text-black transition-colors text-sm">
                <SocialIcon name={s.name} className="size-4" />
                {s.name}
              </a>
            ))}
          </div>

        </div>
      </div>
      <div className="max-w-[1400px] mx-auto w-full mt-16 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-400">
        <p>© 2026 SANAN. Todos los derechos reservados.</p>
        <div className="flex gap-6">
        </div>
      </div>
    </footer>
  );
};

export default Footer;
